<ng-container *ngIf="player">

    <div class="card-body">
        <h5 class="card-title">{{player.name}}</h5>
        <h6>{{player.class}} <span class="badge text-bg-secondary">{{player.tier+1}}</span> [{{player.level}}]</h6>

        <div>Health: {{player.health}} / {{player.health_max}}</div>
        <div>Energy: {{player.energy}} / {{player.energy_max}}</div>

        <ng-container *ngIf="!showAttributes">
            <div>Experience: {{player.exp}}</div>
        </ng-container>
    </div>


    <div class="card-body" *ngIf="showAttributes">
        <div>Experience: {{player.exp}}</div>
        <div>level up:
            <button [disabled]="!CanLevel(player)" (click)="Levelup(player)">{{CanLevelLabel(player)}}</button>
        </div>
        <!-- <div>buy attributes point:
            <button [disabled]="!HasFreepointExp()" (click)="BuyFreepoint()">{{NextFreepointExp()}} EXP</button>
        </div> -->

    </div>

    <div class="card-body" *ngIf="showEquipment">
        <div *ngFor="let item of player.equipment">
            {{item.name}} <span *ngIf="item.tier > 1" class="badge text-bg-secondary">{{item.tier}}</span>
        </div>
    </div>

    <div class="card-body" *ngIf="showAttributes">
        <div *ngIf="player.freepoints">unused attribute points: {{player.freepoints}}
        </div>

        <div>attack: {{player.attributes.attack}} <span *ngIf="player.equipment_attributes.attack">(+
                {{player.equipment_attributes.attack}})</span> <strong *ngIf="player.freepoints "
                (click)="Increment('attack')">+</strong>
        </div>

        <div>defense: {{player.attributes.defense}} <span *ngIf="player.equipment_attributes.defense">(+
                {{player.equipment_attributes.defense}})</span> <strong *ngIf="player.freepoints "
                (click)="Increment('defense')">+</strong>
        </div>

        <div>vitality: {{player.attributes.vitality}} <span *ngIf="player.equipment_attributes.vitality">(+
                {{player.equipment_attributes.vitality}})</span> <strong *ngIf="player.freepoints"
                (click)="Increment('vitality')">+</strong>
        </div>

        <div>stamina: {{player.attributes.stamina}} <span *ngIf="player.equipment_attributes.stamina">(+
                {{player.equipment_attributes.stamina}})</span><strong *ngIf="player.freepoints "
                (click)="Increment('stamina')">+</strong></div>
    </div>
</ng-container>